import React from "react";
import { Text } from "@website-builder/ui/shared/elements";

function RenderMixedString(props) {
	const { mixedString, color } = props;
	/**
	 * Sometimes we get &nbsp; in label field from Hubspot Get Form API.
	 * It is visible as &nbsp; or &#xa0; (numeric character reference) after conversion
	 * so we are replacing it with space character to display it properly.
	 */
	const stringWithoutNbsp = mixedString.replace(/&nbsp;|&#xa0;/g, " ");
	// Split the mixed string into parts using regex to find HTML tags
	const parts = stringWithoutNbsp?.split(/(<[a-zA-Z]+[^>]*>.*?<\/[a-zA-Z]+>)/g);
	// Map the parts and render them using dangerouslySetInnerHTML for HTML tags
	const renderedContent = parts.map((part, index) => {
		if (part.startsWith("<") && part.endsWith(">")) {
			// Render HTML tags using dangerouslySetInnerHTML
			return (
				<Text
					key={index}
					dangerouslySetInnerHTML={{ __html: part }}
					color={color}
					style={{ display: "inline" }}
					className="text-with-inner-html"
				/>
			);
		} else {
			// Render plain text
			return (
				<Text
					className="text"
					key={index}
					color={color}
					style={{ display: "inline" }}
				>
					{part}
				</Text>
			);
		}
	});

	return <div>{renderedContent}</div>;
}

export default RenderMixedString;
